import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-red-400 text-left"
}
const _hoisted_2 = {
  key: 1,
  class: "text-red-400 text-left"
}
const _hoisted_3 = { class: "flex justify-between mt-4" }
const _hoisted_4 = { class: "px-4 py-2 rounded-lg bg-primary text-white hover:bg-green-600 focus:bg-green-600" }
const _hoisted_5 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: `Formulario de nomina de trabajadores`,
    onOnClose: _ctx.closeModal,
    visible: _ctx.showModalAdd,
    "onUpdate:visible": _cache[7] || (_cache[7] = (e) => _ctx.showModalAdd = e)
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "px-4 py-2 mr-2 rounded-lg bg-gray-300 hover:bg-gray-400 focus:bg-gray-400",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, " Cancelar "),
        _createElementVNode("button", _hoisted_4, [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveUser && _ctx.saveUser(...args)))
              }, "Guardar"))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _hoisted_7))
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.emptyFields)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " *Verificar que email y número de telefono tengan el formato correcto "))
        : _createCommentVNode("", true),
      (_ctx.hasError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " *Verifica que todos los campos esten rellenados "))
        : _createCommentVNode("", true),
      _createVNode(_component_TextField, {
        label: "Primer nombre",
        model: _ctx.workerUserData.user_info.firstName,
        "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.workerUserData.user_info.firstName) = $event)),
        type: "text",
        name: "descripcion",
        placeholder: 'ej: Juan',
        hasError: _ctx.hasErrorNombre,
        "error-message": _ctx.hasErrorNombre ? 'El nombre está vacío' : ''
      }, null, 8, ["model", "hasError", "error-message"]),
      _createVNode(_component_TextField, {
        label: "Apellido",
        model: _ctx.workerUserData.user_info.lastName,
        "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.workerUserData.user_info.lastName) = $event)),
        type: "text",
        name: "apellido",
        placeholder: 'ej: Rojas',
        hasError: _ctx.hasErrorApellido,
        "error-message": _ctx.hasErrorApellido ? 'El Apellido está vacío' : ''
      }, null, 8, ["model", "hasError", "error-message"]),
      _createVNode(_component_TextField, {
        label: "Telefono",
        model: _ctx.workerUserData.user_info.phone,
        "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.workerUserData.user_info.phone) = $event)),
        type: "text",
        name: "Telefono",
        placeholder: 'ej: +56911111111'
      }, null, 8, ["model"]),
      _createVNode(_component_TextField, {
        label: "Correo electrónico",
        name: "email",
        type: "string",
        model: _ctx.workerUserData.user_info.email,
        "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.workerUserData.user_info.email) = $event)),
        placeholder: 'ej: ejemplo@gmail.com',
        class: "w-full",
        "has-error": _ctx.hasErrorEmail,
        "error-message": _ctx.hasErrorEmail ? 'El Correo está vacío' : ''
      }, null, 8, ["model", "placeholder", "has-error", "error-message"]),
      _createVNode(_component_TextField, {
        label: "Cargo",
        model: _ctx.workerUserData.communityUserEdit.position,
        "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.workerUserData.communityUserEdit.position) = $event)),
        placeholder: 'ej: Conserje',
        type: "text",
        name: "position"
      }, null, 8, ["model"]),
      (_ctx.showModalAlert)
        ? (_openBlock(), _createBlock(_component_ModalAlert, {
            key: 2,
            visible: _ctx.showModalAlert,
            option: true,
            onAccept: _ctx.handleAccept,
            onCancelAlert: _ctx.handleAccept
          }, null, 8, ["visible", "onAccept", "onCancelAlert"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onOnClose", "visible"]))
}